import React from "react";
import MonitorsListView from "./MonitorsListView";
import Subheading from "../Common/Subheading";
import EditMonitoringIcon from "../../assets/icons/monitoring/view_manage_monitors-01.svg2";
import WhiteButton from "../Common/WhiteButton";
import MonitoringIcon from "../../assets/icons/monitoring/monitoring-01.svg2";
import StyledTabContainer from "../Common/StyledTabContainer";
import HelpButton from "../HelpContent/HelpButton";

export default function MonitorsTab() {
  return (
    <StyledTabContainer id="monitoring-overview" isBackgroundFixed>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div>
          <Subheading
            Icon={EditMonitoringIcon}
            heading="View / Manage / Edit your Monitors"
            subheading="Track and update your monitors. View real-time data, make quick adjustments, and manage settings."
          />
        </div>
        <div>
          <WhiteButton
            as="RRLink"
            icon={MonitoringIcon}
            heading="Create a"
            subheading="New Monitor"
            to="/monitoring/new"
          />
        </div>
      </div>
      <MonitorsListView />
    </StyledTabContainer>
  );
}
